import { client } from '@atlassian/rovo-content-bridge-api/client-types';

export const CONFLUENCE_SPACE_CLIENT_ID = client('confluence-space');
